module.exports = __webpack_public_path__ + "static/offer-d-3-new-52253e10484305761e90ae192b125859.jpg";